export const SITE_NAME = 'YeTryKar';
export const SITE_TAGLINE = 'Age of Space-Tech Intelligence & Indian Creator Platform';
export const SITE_URL = 'https://yetrykar.com';
export const SUPPORT_EMAIL = 'support@yetrykar.com';
export const APP_VERSION = 'v3.1.1';

/**
 * AdSense Ad Unit Control Flag.
 * Set to true only after AdSense account approval.
 */
export const ENABLE_ADSENSE = false;
